module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabs"
  }, [_c('ul', {
    staticClass: "tabs",
    attrs: {
      "id": 'tabs-' + _vm._uid,
      "data-tabs": ""
    }
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      staticClass: "tabs-title"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: tab.name,
          params: {
            id: _vm.$route.params.id
          }
        },
        "aria-selected": tab.pathName === _vm.$route.meta.name
      }
    }, [_vm._v(_vm._s(tab.headerName))])], 1)
  }), 0), _c('div', {
    staticClass: "tabs-content",
    attrs: {
      "data-tabs-content": _vm.$route.meta.name
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac2e18b6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/foundation/RouterTabHeaders.vue
// module id = 2658
// module chunks = 1